// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.action-bar {
  display: flex;
  align-items: center;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 0.375rem;
  margin-top: 20px;
}
.action-bar input[type=checkbox] {
  margin-right: 10px;
  cursor: pointer;
}
.action-bar button {
  border: none;
  background-color: transparent;
  margin-right: 10px;
}
.action-bar button:last-child {
  margin-right: 0;
}
.action-bar button .actionbar-icons {
  width: 18px;
  height: 18px;
  cursor: pointer;
  color: #686868;
}`, "",{"version":3,"sources":["webpack://./src/components/ActionBar/ActionBar.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EAEA,sBAAA;EACA,uBAAA;EACA,gBAAA;AAAF;AAEE;EACE,kBAAA;EACA,eAAA;AAAJ;AAGE;EACE,YAAA;EACA,6BAAA;EACA,kBAAA;AADJ;AAGI;EACE,eAAA;AADN;AAII;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAFN","sourcesContent":[".action-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 10px;\r\n  // box-shadow: 0 1px 3px var(--boxshadow-color);\r\n  border: 1px solid #ddd;\r\n  border-radius: 0.375rem;\r\n  margin-top: 20px;\r\n\r\n  input[type=\"checkbox\"] {\r\n    margin-right: 10px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  button {\r\n    border: none;\r\n    background-color: transparent;\r\n    margin-right: 10px;\r\n\r\n    &:last-child {\r\n      margin-right: 0;\r\n    }\r\n\r\n    .actionbar-icons {\r\n      width: 18px;\r\n      height: 18px;\r\n      cursor: pointer;\r\n      color: #686868;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
